module.exports = __webpack_public_path__ + "img/table-graph-sm.89b4de5f.svg";